import * as React from "react";
import { connect } from "react-redux";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import QueuedNotifications from "../NotificationQueue/QueuedNotifications";
import SentNotifications from "../NotificationQueue/SentNotifications";
import SentNotificationsPaged from "../NotificationQueue/SentNotificationsPaged";
import QueuedNotificationsPaged from "../NotificationQueue/QueuedNotificationsPaged";

export interface NotificationTabContainerProps {
  setSelectedTab?: (key: string) => void;
}

class NotificationTabContainer extends React.Component<NotificationTabContainerProps, any> {
  public render() {
    return (
      <div>
        <Tabs defaultActiveKey="queued" id="notification-tabs">
          <Tab eventKey="queued" title="Queued">
            <QueuedNotificationsPaged />
          </Tab>
          <Tab eventKey="sent" title="Sent">
            <SentNotificationsPaged />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {};
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationTabContainer);
